import { upload } from 'consts'

const flatten = arr => [].concat.apply([], arr)
const isIgnoredFile = name =>
  upload.systemFiles.findIndex(val => val === name) === -1

const getFilesFromEntry = (acc, entry) => {
  if (entry.isFile) {
    if (isIgnoredFile(entry.name))
      acc.push(new Promise(resolve => entry.file(resolve)))
  } else if (entry.isDirectory) {
    acc.push(
      new Promise((resolve, reject) => {
        const dirReader = entry.createReader()
        dirReader.readEntries(entries => {
          Promise.all(entries.reduce(getFilesFromEntry, []))
            .then(flatten)
            .then(resolve)
        })
      })
    )
  }
  return acc
}
const getFilesFromDataTransfer = (acc, file) => {
  return [
    ...acc,
    new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        resolve(file)
      }
      reader.onerror = e => {
        const error = reader.error
        switch (error.code) {
          case error.NOT_READABLE_ERR:
            reject(new Error('noFolderUploadSupport'))
            break
          default:
            reject(new Error('uploadFailed'))
        }
      }
    })
  ]
}

export function getDataTransferItems(event) {
  return new Promise((resolve, reject) => {
    const dt = event.dataTransfer
    if (dt.items && dt.items.length && 'webkitGetAsEntry' in dt.items[0]) {
      Promise.all(
        [].slice
          .call(dt.items)
          .map(item => item.webkitGetAsEntry())
          .reduce(getFilesFromEntry, [])
      )
        .then(flatten)
        .then(resolve)
    } else if (dt.files && dt.files.length) {
      Promise.all([].slice.call(dt.files).reduce(getFilesFromDataTransfer, []))
        .then(resolve)
        .catch(reject)
    } else if (event.target && event.target.files) {
      resolve(event.target.files)
    } else {
      reject(new Error('noFolderUploadSupport'))
    }
    // During the drag even the dataTransfer.files is null
    // but Chrome implements some drag store, which is accesible via dataTransfer.items
  })
}



// WEBPACK FOOTER //
// ./src/components/Media/FileDropZone/getDataTransferItems.js